import { BrandListingItemViewModel } from '@/types/api';
import { getBaseURL } from '@/features/navigation/utils/url-helpers';
import { AppNextLink } from '@/features/app-next-link';
import { IconSearchNormal } from '@/components/svg-symbols/icons';
import { PLPPages } from '@/app/(plp)/types';
interface Props {
  brands: BrandListingItemViewModel[];
}
export default function SearchBrandResult({
  brands
}: Props) {
  const items = brands.map(({
    id,
    nameEn,
    nameFa,
    slug
  }) => <li key={id}>
            <AppNextLink href={`/${getBaseURL({
      page: PLPPages.Brands,
      slug: slug || ''
    })}`} className='flex h-9 items-center text-body-14 text-text-black' prefetch={false}>
                <IconSearchNormal className='ml-2 h-6 w-6' />
                <div>
                    <span>{`${nameFa} `}</span>
                    <span className='text-text-mediumGray'>({nameEn})</span>
                </div>
            </AppNextLink>
        </li>);
  return <ul className='mb-4 mt-2 pr-1.5 lg:mt-0' data-sentry-component="SearchBrandResult" data-sentry-source-file="search-brand-result.tsx">{items}</ul>;
}